import axios from 'axios';
import dayjs from 'dayjs';
import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import Tooltip from 'src/components/common/Dynamic-old/Tooltip';
import AxiosConfig from 'src/utilities/AxiosConfig';
import snackBar from 'src/utilities/snackBar/SnackBar';
import './DeleteDenyTime.css'

interface IProps {
    showDeleteModal: boolean;
    setShowDeleteModal: (showDeleteModal: boolean) => void;
    deleting: boolean;
    setDeleting: (deleting: boolean) => void;
    entryToDelete: any;
    setEntryToDelete: (entryToDelete: any) => void;
    inUsePC: any;
    refreshEmployee: any;
    show: boolean;
}

const DeleteDenyTime: React.FC<IProps> = (props: IProps) => {
    //r-18-lint-cm
    //eslint-disable-next-line
    const { showDeleteModal, setShowDeleteModal, deleting, setDeleting, entryToDelete, setEntryToDelete, inUsePC, refreshEmployee, show } = props;

    const handleShowDeleteModal = () => {
        setShowDeleteModal(!showDeleteModal)
    }

    let deletedBy: string | number;

    const deleteEntry = (e: React.MouseEvent) => {
        deletedBy = "";
        deleteTimeEntry(e);
    }

    const denyEntry = (e: React.MouseEvent) => {
        deletedBy = -808479;
        deleteTimeEntry(e);
    }

    const deleteTimeEntry = async (e: React.MouseEvent) => {
        //console.log("Entry", entryToDelete);
        e.preventDefault();
        let rb: any = {
            ...entryToDelete,
            DeletedDate: dayjs().format("MM/DD/YYYY"),
            DeletedBy: deletedBy,
            ProfitCenterId: inUsePC
        };
        setDeleting(true);
        axios.post(process.env.REACT_APP_API_URL + "/api/timeadmin/addedittimeentry", rb, AxiosConfig.configValue("min"))
            .then((res: any) => {
                if (AxiosConfig.checkResponse(res)) {
                    if (res.data.TimeEntry.Validation.IsValid) {
                        refreshEmployee();
                    } else {
                        snackBar({ type: "error", text: res.data.TimeEntry.Validation.ValidationMessages[0].Item2 || "There was an error processing your request.", timeout: 3000 })
                    }
                }
                //console.log("RES: ", res);
                setDeleting(false);
            })
            .catch((err: any) => {
                //console.log(err, err.response);
            })
            .finally(() => {
                handleShowDeleteModal();
                setDeleting(false);
            })
    }

    return (
        <Modal
            show={true}
        >
            <Modal.Header>
                {
                    entryToDelete.FieldTimeCodeId === 97 ?
                        <h5><strong>Delete or Deny Time</strong></h5> :
                        <h5><strong>Delete Time</strong></h5>
                }
                {
                    entryToDelete.FieldTimeCodeId === 97 &&
                    <Tooltip name="TT-Delete-Deny" placement="right" iconClassName='delete-deny-tooltip text-info' />
                }

            </Modal.Header>
            <Modal.Body >
                {
                    deleting ?
                        <>
                            <div className='d-flex flex-row'>
                                <Spinner size="sm" animation="border" className='mr-3 mt-1' />
                                <h5 className='mb-2'>Delete/Deny Hours</h5>
                            </div>
                        </>
                        : entryToDelete.FieldTimeCodeId === 97 ?
                            <h5>Would you like to Delete or Deny this time entry?</h5> :
                            <h5>Delete this time Entry?</h5>
                }
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-outline-secondary' onClick={handleShowDeleteModal}>Cancel</button>
                <button className='btn btn-outline-danger' onClick={deleteEntry}>Delete</button>
                {
                    entryToDelete.FieldTimeCodeId === 97 &&
                    <button className='btn btn-outline-warning' onClick={denyEntry} >Deny</button>
                }

            </Modal.Footer>
        </Modal>
    )
}

export default DeleteDenyTime;